<cm-base-error-page [config]="config"></cm-base-error-page>
